/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservableSpacesPathParameters } from 'api/actions/get-reservable-spaces/get-reservable-spaces-path-parameters';
import { GetReservableSpacesResponse } from 'api/actions/get-reservable-spaces/get-reservable-spaces-response';

type GetReservableSpacesQueryParameters = Record<string, any>;

/**
 * The path of the GetReservableSpaces action.
 */
export const getReservableSpacesActionPath = new SweetPath<keyof GetReservableSpacesPathParameters>(
  '/reservations/spaces',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservableSpaces actions.
 */
export default function createGetReservableSpacesAction(axios: AxiosInstance) {
  return function getReservableSpacesAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetReservableSpacesQueryParameters } = {}) {
    const path = getReservableSpacesActionPath.original;

    return axios.get<GetReservableSpacesResponse, GetReservableSpacesResponse>(path, { params: query, headers });
  };
}
